import type { EventName } from "@lit/react";
import { RadioButton as RadioButtonElement, type RadioButtonEventMap as _RadioButtonEventMap, } from "@vaadin/radio-group/vaadin-radio-button.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { RadioButtonElement, };
export type RadioButtonEventMap = Readonly<{
    onCheckedChanged: EventName<_RadioButtonEventMap["checked-changed"]>;
}>;
const events = { onCheckedChanged: "checked-changed" } as RadioButtonEventMap;
export type RadioButtonProps = WebComponentProps<RadioButtonElement, RadioButtonEventMap>;
export const RadioButton = createComponent({
    elementClass: RadioButtonElement, events, react: React, tagName: "vaadin-radio-button"
});
